import React, { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import type { PermissionDecision, PermissionEvaluationInput, PermissionSurface } from '../../types/permissions'
import { usePermissionDecision } from '../../permissions'

type RouteGuardProps = {
  children: ReactNode
  surface?: PermissionSurface
  decision?: PermissionDecision
  input?: PermissionEvaluationInput
  redirectTo?: string
  fallback?: ReactNode
}

const RouteGuard: React.FC<RouteGuardProps> = ({
  children,
  surface,
  decision,
  input,
  redirectTo = '/403',
  fallback,
}) => {
  const computedDecision = usePermissionDecision(surface, input)
  const resolvedDecision = decision ?? computedDecision

  if (resolvedDecision.allowed) {
    return <>{children}</>
  }

  if (resolvedDecision.outcome === 'render_access_denied' && fallback) {
    return <>{fallback}</>
  }

  return <Navigate replace to={redirectTo} />
}

export default RouteGuard
